import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './HeroSection.scss';

const SRC = 'https://pub-99c08cb1333848799ea7396fa0c922e1.r2.dev/sso/banner_width_1920_v2.jpg';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero__img-wrap">
        <img src={SRC} alt={t('trangChu.hero.imgAlt')} className="hero__img" />

        <div className="hero__overlay" aria-hidden="true" />

        <div className="hero__content">
          <span className="hero__badge">{t('trangChu.hero.badge')}</span>

          <h1 className="hero__title">
            {t('trangChu.hero.title')}<br />
            <span className="hero__title-accent">{t('trangChu.hero.titleAccent')}</span>
          </h1>

          <p className="hero__desc">
            {t('trangChu.hero.desc')}<br />
            <strong>{t('trangChu.hero.descStrong')}</strong>
          </p>

          <div className="hero__actions">
            <Link to="/tao-don" className="hero__btn hero__btn--primary">
              {t('trangChu.hero.btnCreate')}
            </Link>
            <Link to="/tra-cuu" className="hero__btn hero__btn--outline">
              {t('trangChu.hero.btnTrack')}
            </Link>
          </div>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-num">34+</span>
              <span className="hero__stat-label">{t('trangChu.hero.statProvinces')}</span>
            </div>
            <div className="hero__stat-sep" />
            <div className="hero__stat">
              <span className="hero__stat-num">300+</span>
              <span className="hero__stat-label">{t('trangChu.hero.statPartners')}</span>
            </div>
            <div className="hero__stat-sep" />
            <div className="hero__stat">
              <span className="hero__stat-num">99.8%</span>
              <span className="hero__stat-label">{t('trangChu.hero.statOnTime')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
